import { createMergeReducer } from '../utils/reducer'

export interface SeasonInfo {
  seasonId: string
  seasonLink: string
}

export type TitleIdToSeasonInfos = {
  [titleId: string]: SeasonInfo[] | undefined
}

export const reducer = createMergeReducer(
  t => t.seasons,
  {} as TitleIdToSeasonInfos
)
